
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    labelWidth: {
      type: String,
      default: '150px'
    },
    data: {
      type: Array,
      default: () => [] as any
    }
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
})
